import React from "react";
import PropTypes from "prop-types";

const Input = ({ label, placeholder, required, type, onChange, error , fullWidth, id, disabled, className, readOnly, defaultValue, value }) => {
  return (
    <>
      {label &&
        <label className="text-sm font-medium text-gray-800 block mb-1.5">
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      }
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        className={`${fullWidth? "w-full" : ""} p-2 border border-gray-300 rounded-md outline-none focus:border-primary focus:ring-1 focus:ring-primary placeholder-gray-500 ${className}`}
        onChange={onChange}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        defaultValue={value}
      />
      {error && 
        <label className="text-sm font-medium text-red-500 block mt-1">
          * {error}
        </label>
        }
    </>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  id: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  defaultValue:PropTypes.string
};

Input.defaultProps = {
  placeholder: "",
  required: false,
  type: "text",
  onChange: () => {},
  fullWidth: false,
  disabled: false,
  className: "",
  readOnly: false,
  defaultValue:""
};

export default Input;
